<div class="user-type-selector-container">
  <h4 class="user-type-selector__title">
    {{ 'header.userTypeSelect.title' | transloco }}
  </h4>
  <button
    boelsButton
    variant="secondary"
    [icon]="fasUserTie"
    (click)="closeModal(userTypeEnum.BUSINESS)"
  >
    {{ 'header.userTypeSelect.business' | transloco }}
  </button>
  <button
    boelsButton
    variant="secondary"
    [icon]="faUser"
    (click)="closeModal(userTypeEnum.INDIVIDUAL)"
  >
    {{ 'header.userTypeSelect.individual' | transloco }}
  </button>
</div>
